import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Step from '../../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../../components/Form/RadioBlock'
import Field from '../../../../../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../../../../../features/components/Form/FieldLabelWrapper'

import { formatOptionsList } from '../../../../../../../../features/formatters'

import { selectedGoogleAdAccountSelector } from '../../../../../../../../modules/selectors/adAccounts'
import { lineItemsSelector } from '../../../../../../../../modules/selectors/lineItems'

import { CPM_BID } from '../../../../../../LineItemForms/LineItemGoogleCreate/LineItemGoogleCreateForm/LineItemGoogleCreateMainForm/fields'
import { LINE_ITEM } from '../../../../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/fields'
import {
  LIST_ITEM_OPTION,
  OPTION_EXISTING_LIST_ITEM,
  OPTION_NEW_LIST_ITEM
} from '../../../../../../../../hooks/formHooks/listItemFormHooks/fields'

const stepFields = [LINE_ITEM, CPM_BID]

const LineItemStep = ({ formik, handleStepChange, isOnlyLineItemStep, isRightAllocationBudget }) => {
  const { t } = useTranslation()

  const { currency_symbol: currencySymbol } = useSelector(selectedGoogleAdAccountSelector)
  const lineItems = useSelector(lineItemsSelector)

  const { values, setFieldValue } = formik

  const formattedLineItems = formatOptionsList({
    list: lineItems,
    valueName: 'id',
    labelName: 'name'
  })

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step
      stepTitle="Which ad group should the ad be uploaded to?"
      handleContinue={isOnlyLineItemStep ? null : handleContinue}
    >
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_existing_ad_group"
        name={LIST_ITEM_OPTION}
        label={t('An existing ad group')}
        value={OPTION_EXISTING_LIST_ITEM}
        selectedValue={values[LIST_ITEM_OPTION]}
      >
        <Field formik={formik} name={LINE_ITEM} placeholder={t('Select an ad group')} options={formattedLineItems} />
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_new_ad_group"
        name={LIST_ITEM_OPTION}
        label={t('A new ad group')}
        value={OPTION_NEW_LIST_ITEM}
        selectedValue={values[LIST_ITEM_OPTION]}
      >
        {isRightAllocationBudget && (
          <FieldLabelWrapper label={t('Bid cap for CPM')} labelFor={CPM_BID}>
            <p>{t('Enter your viewable cost per thousand impressions (CPM) bid for this ad group.')}</p>
            <Field
              symbol={currencySymbol}
              placeholder="CPM Bid"
              disablePlaceholderFormatting
              name={CPM_BID}
              formik={formik}
              type="number"
            />
          </FieldLabelWrapper>
        )}
      </RadioBlock>
    </Step>
  )
}

export default LineItemStep
